export default "__VITE_ASSET__BEUom9al__"